export const minecraftJarSide = ['mcsrv.dev', 'beta.mcsrv.dev'].includes(window.location.hostname)
    ? 'server'
    : 'client';
